// Auto-detect backend URL based on current domain
// In production (zampa.one, zampa.app), use the same domain
// In preview, use the env variable

const getBackendUrl = () => {
  const hostname = window.location.hostname;
  
  // Production domains - use same origin
  if (hostname === 'zampa.one' || hostname === 'zampa.app' || hostname === 'www.zampa.one' || hostname === 'www.zampa.app') {
    return window.location.origin;
  }
  
  // Preview or development - use env variable
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

export const BACKEND_URL = getBackendUrl();
export const API = BACKEND_URL + '/api';
